import { createAction, handleActions } from 'redux-actions'
import * as globalMessageActions from '../global-message'
import Y from '../../y18n'
import api from '../api'

const APPLY_FILTER = createAction('subscription-packs/apply-filter') //NOT DONE

const CLEAR_ACTIVE = createAction('subscription-packs/clear-active')
const CLEAR_FILTER = createAction('subscription-packs/clear-filter') //NOT DONE
const CLEAR_ERROR = createAction('subscription-packs/clear-error')
const CLEAR_NEW = createAction('subscription-packs/clear-new')
const CLEAR_SUBSCRIPTION_PACKS = createAction('subscription-packs/clear')
const CLEAR_SUBSCRIPTION_PACK_EVENTS = createAction('subscription-packs/events/clear')

const CREATE_SUBSCRIPTION_PACK = createAction('subscription-packs/create')
const CREATE_SUBSCRIPTION_PACK_SUCCESS = createAction('subscription-packs/create/success')
const CREATE_SUBSCRIPTION_PACK_FAILED = createAction('subscription-packs/create/failed')

const DELETE_SUBSCRIPTION_PACK = createAction('subscription-packs/delete')
const DELETE_SUBSCRIPTION_PACK_SUCCESS = createAction('subscription-packs/delete/success')
const DELETE_SUBSCRIPTION_PACK_FAILED = createAction('subscription-packs/delete/failed')

const GET_SUBSCRIPTION_PACKS = createAction('subscription-packs/get')
const GET_SUBSCRIPTION_PACKS_SUCCESS = createAction('subscription-packs/get/success')
const GET_SUBSCRIPTION_PACKS_FAILED = createAction('subscription-packs/get/failed')

const GET_SUBSCRIPTION_PACK_EVENTS = createAction('subscription-packs/events/get')
const GET_SUBSCRIPTION_PACK_EVENTS_SUCCESS = createAction('subscription-packs/events/get/success')
const GET_SUBSCRIPTION_PACK_EVENTS_FAILED = createAction('subscription-packs/events/get/failed')

const UPDATE_SUBSCRIPTION_PACK = createAction('subscription-packs/update')
const UPDATE_SUBSCRIPTION_PACK_SUCCESS = createAction('subscription-packs/update/success')
const UPDATE_SUBSCRIPTION_PACK_FAILED = createAction('subscription-packs/update/failed')

const SET_ACTIVE = createAction('subscription-packs/set-active')
const UPDATE_ACTIVE = createAction('subscription-packs/update-active')

const SET_PAGE = createAction('subscription-packs/set-page')
const SET_ROWS = createAction('subscription-packs/set-rows')
const SET_NEW = createAction('subscription-packs/set-new')
const SET_SUBSCRIPTION_PACK_EVENTS_PAGE = createAction('subscription-packs/events/get/set-page')

const OPEN_DIALOG = createAction('subscription-packs/open-dialog')

const TABLE_ROWS = 25
const TABLE_PAGE = 0

const EVENT_ROWS = 10
const EVENT_PAGE = 0

const initialState = {
  items: [],
  table: {
    itemCount: 0,
    rows: TABLE_ROWS,
    page: TABLE_PAGE,
    filter: {
      name: "",
      lowerDataLimit: 0,
      upperDataLimit: 0
    }
  },
  loading: false,
  selectedItems: [], // UNUSED but requred for table-toolbar  
  currentState: {
    edit: false,
    events: false,
    new: false,
    error: false
  },
  active: null,
  errorData: {},
  event: {
    items: [],
    itemCount: 0,
    rows: EVENT_ROWS,
    page: EVENT_PAGE
  }
}

export default handleActions({
    [APPLY_FILTER]: (state, action) => {
      let table = {...state.table}
      table.filter[action.payload.name] = action.payload.value
      return {...state, table}
    },
    [CLEAR_ACTIVE]: (state, action) => ({
      ...state,
      active: null,
    }),
    [CLEAR_FILTER]: (state, action) => {
      let table = {...state.table}
      table.filter = {
        name:"",
        tags:"",
        endpointsOnly: false,
        dataTreshold: 0
      }

      return {
      ...state,
        table
    }},
    [CLEAR_ERROR]: (state, action) => {
      let currentState = {...state.currentState}
      currentState.error = false
      return {
      ...state,
      currentState,
      errorData: {}
    }},
    [CLEAR_NEW]: (state, action) => {
      let currentState = {...state.currentState}
      currentState.new = false
      return {
      ...state,
      currentState,
      active: null
    }},
    [CLEAR_SUBSCRIPTION_PACKS]: (state, action) => {
      
      let currentState = {...state.currentState}
      let table = {...state.table}
      currentState.edit = false
      currentState.new = false
      currentState.events = false
      table.itemCount = 0

      return {
      ...state,
      currentState,
      table,
      active: null,
      items: []
    }},
    [CLEAR_SUBSCRIPTION_PACK_EVENTS]: (state, action) => {
      let event = {...state.event}
      event.items = []
      event.itemCount = 0

      return{
      ...state,
      event
    }},
    [CREATE_SUBSCRIPTION_PACK]: (state, action) => ({
      ...state,
      loading: true
    }),
    [CREATE_SUBSCRIPTION_PACK_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [CREATE_SUBSCRIPTION_PACK_FAILED]: (state, action) => {
      let currentState = {...state.currentState}
      state.error = true
      return {
      ...state,
      currentState,
      loading: false,
      errorData: action.payload
    }},
    [DELETE_SUBSCRIPTION_PACK]: (state, action) => ({
      ...state,
      loading: true
    }),
    [DELETE_SUBSCRIPTION_PACK_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [DELETE_SUBSCRIPTION_PACK_FAILED]: (state, action) => {
      let currentState = {...state.currentState}
      currentState.error = true

      return {
      ...state,
      currentState,
      loading: false,
      errorData: action.payload
    }},
    [UPDATE_SUBSCRIPTION_PACK]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_SUBSCRIPTION_PACKS]: (state, action) => {
      let table = {...state.table}
     
      table.itemCount = 0
      table.page = 0
      
      return {
      ...state,
      table,
      items: [],
      loading: true
    }},
    [GET_SUBSCRIPTION_PACKS_SUCCESS]: (state, action) => {
      let table = {...state.table}
      table.itemCount = action.payload.count
      table.page = action.payload.page

      return {
      ...state,
      table,
      items: action.payload.subscriptionPacks,
      loading: false
    }},
    [GET_SUBSCRIPTION_PACKS_FAILED]: (state, action) => {
      let currentState = {...state.currentState}
      currentState.error = true

      return{
      ...state,
      currentState,
      loading: false,
      errorData: action.payload
    }},
    [GET_SUBSCRIPTION_PACK_EVENTS]: (state, action) => {
      let event = {...state.event}
      event.items = []
      event.itemCount = 0
      event.page = 0
    
      return {
      ...state,
      event,
      loading: true
    }},
    [GET_SUBSCRIPTION_PACK_EVENTS_SUCCESS]: (state, action) => {
      let event = {...state.event}
      event.items = action.payload.events  ? action.payload.events : []
      event.itemCount = action.payload.count ? action.payload.count : 0
      event.page = action.payload.page ? action.payload.page : 0

      return {
      ...state,
      event,
      loading: false
    }},
    [GET_SUBSCRIPTION_PACK_EVENTS_FAILED]: (state, action) => {
      let currentState = {...state.currentState}
      let event = {...state.event}
      currentState.error = true
      event.items = []
      event.itemCount = 0
      event.page = EVENT_PAGE
      event.rows = EVENT_ROWS

      return {
      ...state,
      currentState,
      event,
      errorData: action.payload,
      loading: false
    }},
    [UPDATE_ACTIVE]: (state, action) => {
      var active = state.active
      active[action.payload.name] = action.payload.value
      return { ...state, active: active }
    },
    [UPDATE_SUBSCRIPTION_PACK_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [UPDATE_SUBSCRIPTION_PACK_FAILED]: (state, action) => {
      let currentState = {...state.currentState}
      currentState.error = true

      return {
      ...state,
      currentState,
      loading: false,
      errorData: action.payload
    }},
    [SET_ACTIVE]: (state, action) => ({
      ...state, 
      active: {...action.payload}
    }),
    [SET_NEW]: (state, action) => {
      let currentState = {...state.currentState}
      
      currentState.new = true
      return {
      ...state,
      currentState,
      active: action.payload
    }},
    [SET_PAGE]: (state, action) => {
      let table = {...state.table}
      table.page = action.payload
      return {
      ...state,
      table
    }},
    [SET_ROWS]: (state, action) => {
      let table = {...state.table}
      table.rows = action.payload
      return {
      ...state,
      rows: action.payload
    }},
    [SET_SUBSCRIPTION_PACK_EVENTS_PAGE]: (state, action) => {
      let event = {...state.event}
      event.page = action.payload

      return {
      ...state,
      event
    }},
    [OPEN_DIALOG]: (state, action) => ({
      ...state,
      currentState: action.payload 
      }
    )
  },
  initialState
)

export const applyFilter = (name, value) => {
  return dispatch => {
    dispatch(APPLY_FILTER({name, value}))
  }
}

export const clearActive = () => {
  return dispatch => {
    dispatch(CLEAR_ACTIVE())
  }
}

export const clearFilter = () => {
  return dispatch => {
    dispatch(CLEAR_FILTER())
  }
}

export const clearError = () => {
  return dispatch => {
    dispatch(CLEAR_ERROR())
    
  }
}

export const clearNew = () => {
  return dispatch => {
    dispatch(CLEAR_NEW())
  }
}

export const clearSubscriptionPacks = () => {
  return dispatch => {
    dispatch(clearSubscriptionPackEvents())
    dispatch(CLEAR_SUBSCRIPTION_PACKS())
  }
}

export const clearSubscriptionPackEvents = () => {
    return dispatch => {
      dispatch(clearActive())
      dispatch(CLEAR_SUBSCRIPTION_PACK_EVENTS())
    }
}

export const createSubscriptionPack = (subscriptionPack) => {
  return async dispatch => {
      dispatch(CREATE_SUBSCRIPTION_PACK())
      try {
      const result = await api
        .post('subscriptionpacks/create', '', subscriptionPack)
      dispatch(CREATE_SUBSCRIPTION_PACK_SUCCESS(result))
      dispatch(clearNew())
      dispatch(getSubscriptionPacks())
    }
    catch (error) {
      CREATE_SUBSCRIPTION_PACK_FAILED(error)
      dispatch(globalMessageActions.setGlobalError(Y`${error}`))
    }
  }
}

export const deleteSubscriptionPack = (id) => {
  return async dispatch => {
    dispatch(DELETE_SUBSCRIPTION_PACK())
    try {
      await api
        .delete('subscriptionpacks/delete', '', `id=${id}`, '')
      dispatch(DELETE_SUBSCRIPTION_PACK_SUCCESS())
      dispatch(clearSubscriptionPacks())
      dispatch(getSubscriptionPacks())
    }
    catch (error) {
      dispatch(DELETE_SUBSCRIPTION_PACK_FAILED(error));
      dispatch(globalMessageActions.setGlobalError(Y`${error}`))
    }
  }
}

export const getSubscriptionPacks = () => {
  return async (dispatch, getState) => {
    const filter =  getState().subscriptionPacks.table.filter
    const page = getState().subscriptionPacks.table.page
    const rows = getState().subscriptionPacks.table.rows
    dispatch(clearSubscriptionPacks()) 
    dispatch(GET_SUBSCRIPTION_PACKS())

    try {
      const result = await api
        .post(`subscriptionpacks/get?page=${page}&rows=${rows}`, ``, filter)
      dispatch(GET_SUBSCRIPTION_PACKS_SUCCESS(result))
    }
    catch (error) {
      dispatch(GET_SUBSCRIPTION_PACKS_FAILED(error))
      dispatch(globalMessageActions.setGlobalError(Y`${error}`))
    }
  }
}

 export const getSubscriptionPackEvents = () => {
  return async (dispatch, getState) => {
    const subscriptionPack = getState().subscriptionPacks.active
    const rows = getState().subscriptionPacks.event.rows
    const page = getState().subscriptionPacks.event.page

    dispatch(clearSubscriptionPackEvents())
    dispatch(GET_SUBSCRIPTION_PACK_EVENTS())
    try {
      const result = await api
        .get(`subscriptionpacks/getevents?id=${subscriptionPack.id}&rows=${rows}&page=${page}`)
      dispatch(GET_SUBSCRIPTION_PACK_EVENTS_SUCCESS(result))
      dispatch(setActive(subscriptionPack))
    }
    catch (error) {
      dispatch(GET_SUBSCRIPTION_PACK_EVENTS_FAILED(error))
      dispatch(globalMessageActions.setGlobalError(error))
    }
  }
 }  

export const setActive = (subscriptionPack) => {
  return dispatch => {
    dispatch(SET_ACTIVE(subscriptionPack))
  }
}

export const setPage = (page = 0) => {
  return dispatch => {
    dispatch(SET_PAGE(page))
  }
}

export const setEventPage = (page = 0) => {
  return dispatch => {
    dispatch(SET_SUBSCRIPTION_PACK_EVENTS_PAGE(page))
  }
}

export const setRows = rows => {
  return dispatch => {
    dispatch(SET_ROWS(rows))
  }
}

export const setNew = () => {
  return dispatch => {
    const emptySubpack = {
      name: "",
      dataPackId: "",
      smsPackId: "",
      data: 0,
      upgradeLimit: 0,
      downgradeLimit: 0,
      upgradeTo: {
        id: "",
        name: ""
      },
      downgradeTo: {
        id: "",
        name: ""
      },
      tags: ""
    }
    dispatch(SET_NEW(emptySubpack))
  }
}

export const updateActive = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_ACTIVE({ name, value }))
  }
}

export const updateSubscriptionPack = (subscriptionPack) => {
  return async dispatch => {
    dispatch(UPDATE_SUBSCRIPTION_PACK())
    try {
      await api
        .post('subscriptionpacks/update', '', subscriptionPack)
      dispatch(UPDATE_SUBSCRIPTION_PACK_SUCCESS())
      dispatch(clearActive())
      dispatch(getSubscriptionPacks())
    }
    catch (error) {
      dispatch(UPDATE_SUBSCRIPTION_PACK_FAILED(error))
      dispatch(globalMessageActions.setGlobalError(Y`${error}`))
    }
  }
}

export const toggleDialog = dialog => {
  return (dispatch, getState) => {
    var currentState = getState().subscriptionPacks.currentState
    if(dialog === 'edit') {
      currentState.edit = !currentState.edit
      currentState.new = false
      currentState.events = false
    }else if(dialog === 'new'){
        currentState.new = !currentState.new
        currentState.edit = false
        currentState.events = false
    }else if(dialog === 'events'){
      currentState.events = !currentState.events
      currentState.new = false
      currentState.edit = false
    }else{
      currentState.new = false
      currentState.edit = false
      currentState.events = false
    }
    dispatch(OPEN_DIALOG(currentState))
  }
}


// WEBPACK FOOTER //
// ./src/store/subscription-packs/index.js